import { useState, useContext, useRef, useEffect } from "react";
import ExperienceContext from "./ExperienceContext";
import { useSelector } from "react-redux";
import {
	showSuccessNotification,
	showErrorNotification,
} from "../../utils/Notifications";
import {
	Image,
	TextInput,
	Group,
	Button,
	Modal,
	Tabs,
	Input,
	Container,
	Loader,
	Text,
	Grid,
	ScrollArea,
	Pagination,
} from "@mantine/core";
import "@google/model-viewer";
import ThreeDViewer from "../../utils/ThreeDViewer";
import { getAssets } from "../../API/getAssets";
import uploadIcon from "../../static/svg/upload.svg";
import uploadMedia from "../../API/uploadMedia";
import videoIMG from "../../static/svg/3d-box.svg";
function ThreeDSpotModal({
	isThreeDSpotOpen,
	setIsThreeDSpotOpen,
	activePanoId,
}) {
	const user = useSelector((state) => state.userInformationReducer.users);
	const { addThreeDSpot } = useContext(ExperienceContext);
	const fileInput = useRef(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [name, setName] = useState("");
	const [recent3DModal, setRecent3DModal] = useState("");
	const [pages, setPages] = useState(1);
	const [activePage, setPage] = useState(1);
	const [activeTab, setActiveTab] = useState("Upload");
	const handleFileUpload = (event) => {
		setUploadedFile(event.target.files[0]);
	};
	const [loading, setLoading] = useState(false);
	const handleCreate = async () => {
		setLoading(true);
		if (name === "") {
			showErrorNotification("Name cannot be empty");
			setLoading(false);
			return;
		} else if (!uploadedFile) {
			showErrorNotification("Please upload a 3D model");
			setLoading(false);
			return;
		}
		const formData = new FormData();
		formData.append("myfile", uploadedFile);
		formData.append(
			"bodyData",
			JSON.stringify({
				UserId: user?.UserId,
				AccountId: user?.AccountId,
				Name: name,
				AssetTypeId: 5,
			})
		);
		const result = await uploadMedia(formData);
		if (result.status === 201) {
			addThreeDSpot(activePanoId, result.data.res, name);
			showSuccessNotification("image uploaded");
		} else {
			showErrorNotification("Image not uploaded");
		}

		setUploadedFile(null);
		setName("");
		setIsThreeDSpotOpen(false);
		setLoading(false);
	};

	const addFromRecent = (model) => {
		addThreeDSpot(activePanoId, model.LocationUrl, model.Name);
		setUploadedFile(null);
		setName("");
		setIsThreeDSpotOpen(false);
	};

	useEffect(() => {
		const recentMedia = async () => {
			const result = await getAssets(user?.UserId, activePage, 5, 10);
			setRecent3DModal(result.data);
			setPages(result.totalPages);
		};
		recentMedia();
	}, [activePage]);
	return (
		<Modal
			centered
			size="lg"
			opened={isThreeDSpotOpen}
			onClose={() => {
				setName("");
				setUploadedFile(null);
				setIsThreeDSpotOpen(false);
			}}
			title="Add 3D Modal"
			styles={{
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			}}
		>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
			<Tabs
				value={activeTab}
				onTabChange={setActiveTab}
				style={{ borderBottom: "none !important" }}
				styles={{
					tabsListWrapper: { borderBottom: "none !important" },
					tabsList: { borderBottom: "none !important" },
				}}
			>
				<Tabs.List>
					<Tabs.Tab
						value="Upload"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Upload
					</Tabs.Tab>
					<Tabs.Tab
						value="Recent"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Recent
					</Tabs.Tab>
				</Tabs.List>
				<Tabs.Panel value="Upload" pt="xs">
					<Container style={{ width: "100%", minHeight: "300px" }}>
						<TextInput
							my={5}
							label="Model Name"
							variant="filled"
							placeholder="Enter model name"
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
									fontWeight: "700",
								},
							}}
							value={name}
							onChange={(event) =>
								setName(event.currentTarget.value)
							}
						/>
						{uploadedFile === null ? (
							<>
								<label
									htmlFor="file-input"
									style={{
										display: "flex",
										width: "100%",
										height: "100%",
										minHeight: "300px",
										alignItems: "center",
										justifyContent: "center",
										flexDirection: "column",
										gap: "10px",
										border: "1px solid #09254E",
										borderRadius: "5px",
										cursor: "pointer",
									}}
								>
									<Image src={uploadIcon} width={75} />
									<Button
										variant="outline"
										my={10}
										px={30}
										size="xs"
										radius={"md"}
										sx={(theme) => ({
											color: theme.colors.white[0],
											borderColor:
												theme.colors.ivisit_light[0],
										})}
										onClick={() => {
											fileInput.current.click();
										}}
									>
										Browse
									</Button>
								</label>
								<Input
									id="file-input"
									ref={fileInput}
									type="file"
									accept=".glb"
									variant="unstyled"
									styles={{
										wrapper: {
											display: "none",
										},
									}}
									onChange={handleFileUpload}
								/>
							</>
						) : (
							<Group
								position="center"
								style={{ width: "100%", height: "450px" }}
							>
								<ThreeDViewer url={uploadedFile} />
							</Group>
						)}
					</Container>
				</Tabs.Panel>
				<Tabs.Panel value="Recent" pt="xs">
					Use recent models
					<ScrollArea
						mt={10}
						style={{ height: 300 }}
						type="auto"
						offsetScrollbars
						scrollbarSize={8}
						scrollHideDelay={500}
					>
						<Grid style={{ minHeight: 270 }}>
							{recent3DModal &&
								recent3DModal.map((item) => {
									return (
										<Grid.Col
											span={3}
											key={item.id}
											onClick={() => {
												addFromRecent(item);
											}}
										>
											<a
												style={{
													cursor: "pointer",
													display: "flex",
													flexDirection: "column",
												}}
											>
												<img
													alt="Recent3DModals"
													style={{
														width: "20%",
														height: "80px",
														margin: "auto",
													}}
													src={videoIMG}
												/>
												<p
													style={{
														textAlign: "center",
														textOverflow:
															"ellipsis",
														whiteSpace: "nowrap",
														fontSize: "14px",
														marginTop: "3px",
														overflow: "hidden",
													}}
												>
													{`${item.Name}.mp4`}
												</p>
											</a>
										</Grid.Col>
									);
								})}
						</Grid>
						{pages !== 1 && (
							<Pagination
								sx={{
									Button: {
										background: "#09254E",
										fontWeight: "600",
										padding: "0px 4px",
										fontSize: "12px",
										border: "none",
									},
									"Button:first-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
									"Button:last-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
								}}
								page={activePage}
								onChange={setPage}
								mt={5}
								total={pages}
								size="xs"
								style={{
									justifyContent: "center",
									color: "pink",
								}}
							/>
						)}
					</ScrollArea>
				</Tabs.Panel>
			</Tabs>
			<Group style={{ width: "100%", justifyContent: "space-between" }}>
				<Group
					style={{
						width: "auto",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						color: "#a4bac6",
						opacity: "0.5",
					}}
				>
					<Text
						size="xs"
						backgroundColor="red"
						color="white"
						style={{ lineHeight: "0px", marginTop: "15px" }}
					>
						{" "}
						Make sure your file size is under 3 MB.
					</Text>
					<Text size="xs" color="white" style={{ lineHeight: "0px" }}>
						Learn More about our platform supported formats and
						restrictions.
					</Text>
				</Group>
				<Group
					style={{
						width: "auto",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={() => {
							setName("");
							setUploadedFile(null);
							setIsThreeDSpotOpen(false);
						}}
					>
						Cancel
					</Button>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={handleCreate}
					>
						Create
					</Button>
				</Group>
			</Group>
		</Modal>
	);
}

export default ThreeDSpotModal;
